import { type IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faCalendarCheck,
  faCircleXmark,
  faCircleCheck,
  faCircleThreeQuartersStroke,
} from "@fortawesome/pro-solid-svg-icons";
import { CampaignRunStatuses } from "enums/CampaignRunStatuses";

export const CampaignRunStatusToIcon: { [key in CampaignRunStatuses]: IconDefinition } = {
  [CampaignRunStatuses.Scheduled]: faCalendarCheck,
  [CampaignRunStatuses.InProgress]: faCircleThreeQuartersStroke,
  [CampaignRunStatuses.Completed]: faCircleCheck,
  [CampaignRunStatuses.Canceled]: faCircleXmark,
};

export const CampaignRunStatusToColor: { [key in CampaignRunStatuses]: string } = {
  [CampaignRunStatuses.Scheduled]: "scheduled",
  [CampaignRunStatuses.InProgress]: "progress",
  [CampaignRunStatuses.Completed]: "complete",
  [CampaignRunStatuses.Canceled]: "canceled",
};
